import React from 'react'

const Individualmedicalbanner = () => {
    return (
        <div>
            <section className="page-header">
                <div className="page-header-bg-medical "></div>
                <div className="container">
                    <div className="page-header__inner">
                        <div className="innerbanner">
                            <h4 className="text-custom-white no-margin">Individual Medical Insurance</h4>
                        </div>
                        <h6 className='para_absdasa'>Best quotes for you !!!</h6>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Individualmedicalbanner